import declare from "dojo/_base/declare";
import Action from "csi/def/Action";
import { Context } from "csi/def/Context";
import { routerStore } from "csi/state/rootStore";
import ApparelBom from "src/Specification/Model/ApparelBom";

const NotifyCollaboratorsAction = declare(Action, {

	/**
	 * @override
	 * Disable action if current revision's state is not in DRAFT
	 */
	hasAccess(ctx: Context): boolean {
		const bom = ctx.getNode();
		if (ApparelBom.userHasBomEditorRole(bom)) {
			const currentRevision = ctx.cache.getNode(bom.CurrentRevision);
			const revision = ctx.cache.getNode(routerStore.locationRevisionUrl);
			return bom && currentRevision.State === "Revision.State:DRAFT" && currentRevision == revision;
		}

		return false;
	},

	/**
	 * @override
	 * Dont show action if BOM's parent is not of type ProductSource
	 */
	validate: function(ctx: Context): boolean {
		const apparelBOM = ctx.getNode();
		const parentNode = ctx.cache.getNode(apparelBOM.__Parent__);
		return parentNode?.$Type === "ProductSource";
	},
});

export = NotifyCollaboratorsAction;